<template>
  <div class="contactPerson formWrapper mb-5">
    <section>
      <div class="formWrapper__header">
        <Icon icon="contact-person" class="formWrapper__header__icon" />
        <h3 class="contactPerson__header">Osoba kontaktowa</h3>
      </div>
    </section>

    <div class="formWrapper__inner">
      <div class="row">
        <div class="col-md-6 col-lg-6">
          <basic-input
            validationRule="required"
            name="contactPersonName"
            label="Imię"
            placeholder="Imię"
            inputType="text"
            v-model="name"/>
        </div>
        <div class="col-md-6 col-lg-6">
          <basic-input
            validationRule="required"
            name="contactPersonSurname"
            label="Nazwisko"
            v-model="surname"
            placeholder="Nazwisko"
            inputType="text" />
        </div>
        <div class="col-md-6 col-lg-6">
          <ValidationProvider
            class="form-group"
            rules="required|email"
            tag="div"
            v-slot="{ errors, dirty, valid , classes }"
            vid="contactPersonEmail"
          >
            <label :class="classes" for="contactPersonEmail"> Służbowy adres email</label>
            <input
              :class="classes"
              class="form-control"
              id="contactPersonEmail"
              name="contactPersonEmail"
              placeholder="Adres email"
              type="email"
              v-model="email"
            >
            <ul class="errors">
              <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
            </ul>
          </ValidationProvider>
        </div>
        <div class="col-md-6 col-lg-6">
          <ValidationProvider
            class="form-group"
            rules="required|confirmed:contactPersonEmail"
            tag="div"
            v-slot="{ errors, dirty, valid , classes }"
          >
            <label :class="classes" for="contactPersonEmailConfirmation"> Potwierdź adres email</label>
            <input
              :class="classes"
              class="form-control"
              id="contactPersonEmailConfirmation"
              name="contactPersonEmailConfirmation"
              placeholder="Powtórz adres email"
              type="email"
              v-model="contactPersonEmailConfirmation"
              @contextmenu.prevent="() => {}"
              @paste.prevent="() => {}"
            >
            <ul class="errors">
              <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
            </ul>
          </ValidationProvider>
        </div>
      </div>
        <p class="text-small">
          Na podany adres e-mail zostanie wysłana e-faktura.
        </p>
        <section class="contactPerson__otherEmail">

           <label class="checkbox-inline">
            <input
              type="checkbox"
              v-model="isOtherEmailChecked"
              name="showOtherEmail"
            >
            Wyślij e-fakturę na inny adres e-mail
          </label>

          <basic-input v-if="isOtherEmailChecked"
            validationRule="required"
            name="otherDeliveryEmail"
            label="Email"
            v-model="otherEmail"
            placeholder="Adres Email"
            inputType="email" />
        </section>

        <section class="contactPersonForm__agreements mt-4">
          <ValidationProvider
            tag="div" ref="contactPersonIsAllowToOrder"
            :rules="{ required: { allowFalse: false } }"
            v-slot="{ errors, dirty, valid , classes }"
          >
            <div>
              <label class="checkbox-inline required" :class="errors.length > 0 ? 'invalid' : ''">
                <input
                  type="checkbox"
                  v-model="isAgreementsChecked"
                  name="contactPersonIsAllowToOrder"
                >
                Oświadczam, że jestem osobą upoważnioną do składania zamówień w imieniu rejestrowanej firmy.
              </label>
            </div>
            <ul class="errors">
              <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
            </ul>
          </ValidationProvider>
        </section>

    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

import Icon from '../Icon.vue';
import basicInput from '../Inputs/basicInput.vue';

export default {
  name: 'ContactPersonFormWrapper',
  components: { basicInput, Icon },
  computed: {
    ...mapFields('contactPerson', ['isAgreementsChecked', 'name', 'surname', 'email', 'isOtherEmailChecked', 'otherEmail']),
  },
  data() {
    return {
      contactPersonEmailConfirmation: '',
    };
  },
  methods: {
    showOtherEmailField() {
      this.isOtherEmailChecked = !this.isOtherEmailChecked;
    },
  },
};
</script>

<style scoped></style>
